import { useQuery } from 'react-query';
import api, { QueryConfig } from '@shared/api';

type SlackConnectionStatusResponse = {
  status: 'CONNECTED' | 'NOT_CONNECTED_CLOUD' | 'NOT_CONNECTED_ONPREM';
};

const getSlackConnectionStatus = async (organizationId: string) => {
  const response = await api.get(
    `/slack/setup/status?organizationId=${organizationId}`
  );

  return response.data.status;
};

export function useSlackConnectionStatus(
  { organizationId }: { organizationId: string },
  config: QueryConfig<SlackConnectionStatusResponse>
) {
  return useQuery(
    ['slack-connection-status', { organizationId }],
    () => getSlackConnectionStatus(organizationId),
    {
      ...config,
      retry: false
    }
  );
}
